<template>
    <ButtonPopup
        :title="$t('Text size')"
        :disabled="editor.state.selection.empty"
        :button-class="[
            'tiptap-btn',
            { 'is-active': (
                editor.isActive('textStyle',{ fontSize: '10' }) ||
                editor.isActive('textStyle',{ fontSize: '12' }) ||
                editor.isActive('textStyle',{ fontSize: '16' }) ||
                editor.isActive('textStyle',{ fontSize: '18' })
            ) }
        ]"
        popup-class="p-0 pt-2 pl-2 popup-content">
        <div class="d-flex align-items-center">
            <span v-if="editor.isActive('textStyle',{ fontSize: '10' })">10px</span>
            <span v-else-if="editor.isActive('textStyle',{ fontSize: '12' })">12px</span>
            <span v-else-if="editor.isActive('textStyle',{ fontSize: '16' })">16px</span>
            <span v-else-if="editor.isActive('textStyle',{ fontSize: '18' })">18px</span>
            <span v-else>Normal</span>
            <ChevronDownIcon size="18" class="ml-1"/>
        </div>
        <template #popup="{ close }">
            <button
                class="tiptap-fontsize-btn"
                :class="{ active: editor.isActive('textStyle', { fontSize: '10' }) }"
                @click="setFontSize('10'); close()">10px</button>
            <button
                class="tiptap-fontsize-btn"
                :class="{ active: editor.isActive('textStyle', { fontSize: '12' }) }"
                @click="setFontSize('12'); close()">12px</button>
            <button
                class="tiptap-fontsize-btn"
                @click="setFontSize(); close()">Normal</button>
            <button
                class="tiptap-fontsize-btn"
                :class="{ active: editor.isActive('textStyle', { fontSize: '16' }) }"
                @click="setFontSize('16'); close()">16px</button>
            <button
                class="tiptap-fontsize-btn"
                :class="{ active: editor.isActive('textStyle', { fontSize: '18' }) }"
                @click="setFontSize('18'); close()">18px</button>
        </template>
    </ButtonPopup>
</template>

<script>
import ButtonPopup from '@/common/components/button-popup/ButtonPopup.vue';
import ChevronDownIcon from '@/common/components/svg-icons/ChevronDownIcon.vue';
import {Editor} from '@tiptap/vue-2';

export default {
    name: 'MenuBarSizeButton',
    props: {
        editor: {
            type: Editor,
            required: true
        }
    },
    methods: {
        setFontSize(size) {
            if (size) {
                this.editor.commands.setFontSize(size);
            } else {
                this.editor.commands.unsetFontSize();
            }
        }
    },
    components: {
        ButtonPopup,
        ChevronDownIcon
    }
};
</script>
